var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg02D(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 392,
    height: 266,
    viewBox: "0 0 392 266",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_7_2015)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_7_2015)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M235.562 233.765C233.629 233.92 231.676 233.999 229.705 234H92.1812C82.7149 234.035 73.3348 232.201 64.579 228.603C55.8232 225.005 47.8639 219.714 41.1577 213.032C34.4516 206.351 29.1305 198.412 25.4997 189.669C21.869 180.927 20 171.554 20 162.087C20 152.621 21.869 143.248 25.4997 134.506C29.1305 125.763 34.4516 117.824 41.1577 111.143C47.8639 104.461 55.8232 99.17 64.579 95.5718C73.3348 91.9737 82.7149 90.1397 92.1812 90.175H143.457C160.081 53.6 198.368 28 242.941 28C302.768 28 351.268 74.115 351.268 131C351.268 187.885 302.768 234 242.941 234C240.461 234 238.001 233.922 235.562 233.765Z",
    fill: "url(#paint0_linear_7_2015)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.941 233C250.227 233 257.508 232.302 264.581 230.926C271.475 229.585 278.255 227.584 284.733 224.978C291.094 222.42 297.229 219.254 302.967 215.568C308.65 211.917 313.994 207.725 318.851 203.107C323.706 198.49 328.114 193.411 331.952 188.009C335.826 182.557 339.154 176.728 341.842 170.686C344.579 164.532 346.681 158.093 348.09 151.547C349.535 144.831 350.268 137.917 350.268 131C350.268 124.082 349.535 117.169 348.09 110.452C346.681 103.906 344.579 97.4673 341.842 91.3142C339.154 85.2716 335.826 79.4433 331.952 73.991C328.114 68.5893 323.706 63.5095 318.851 58.8928C313.994 54.2752 308.65 50.0829 302.967 46.4323C297.229 42.7461 291.094 39.5801 284.733 37.0221C278.255 34.4165 271.475 32.4154 264.581 31.0742C257.508 29.6979 250.227 29 242.941 29C221.57 29 200.931 34.9523 183.254 46.2135C174.734 51.6418 167.077 58.1939 160.497 65.6878C153.876 73.2291 148.449 81.6069 144.367 90.5885L144.1 91.1747H143.456H92.1807C82.6072 91.1747 73.3205 93.0495 64.5787 96.747C60.3771 98.5242 56.3245 100.724 52.5336 103.285C48.7784 105.822 45.2472 108.735 42.038 111.945C38.8288 115.154 35.9152 118.685 33.3783 122.44C30.8172 126.231 28.6175 130.284 26.8404 134.485C23.1429 143.227 21.2681 152.514 21.2681 162.087C21.2681 171.661 23.1429 180.948 26.8404 189.689C28.6175 193.891 30.8172 197.944 33.3783 201.735C35.9152 205.49 38.8288 209.021 42.038 212.23C45.2472 215.439 48.7784 218.353 52.5336 220.89C56.3245 223.451 60.3771 225.651 64.5787 227.428C73.3205 231.125 82.6072 233 92.1807 233H229.705C231.628 233 233.572 232.922 235.482 232.768L235.554 232.762L235.626 232.767C238.046 232.922 240.507 233 242.941 233ZM242.941 234C240.461 234 238 233.921 235.562 233.765C233.632 233.92 231.676 234 229.705 234H92.1807C52.4646 234 20.2681 201.803 20.2681 162.087C20.2681 122.371 52.4646 90.1747 92.1807 90.1747H143.456C160.081 53.5954 198.366 28 242.941 28C302.768 28 351.268 74.1151 351.268 131C351.268 187.885 302.768 234 242.941 234Z",
    fill: "white",
    fillOpacity: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_7_2015",
    x: 0,
    y: 0,
    width: 391.268,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_2015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_2015",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect2_foregroundBlur_7_2015"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_7_2015",
    x: 0,
    y: 0,
    width: 391.268,
    height: 266,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.258824 0 0 0 0 0.627451 0 0 0 0 0.941176 0 0 0 0.596 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_2015"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7_2015",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7_2015",
    x1: 154.164,
    y1: 53.9561,
    x2: 220.206,
    y2: 245.168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.596
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0.204
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg02D);
export default __webpack_public_path__ + "static/media/02d.ed87b38eadd7ed38cdce3ad7169342d6.svg";
export { ForwardRef as ReactComponent };